import React from 'react'
import { useState, CSSProperties } from "react";
import MoonLoader from "react-spinners/MoonLoader";
export default function Loading() {

   
     
  return <>
  <div className='loading mt-5 '>
  <MoonLoader color="rgba(54, 215, 183, 1)" />
  
  </div>
  </>
}
